import { Component, Output, Input } from '@angular/core';
import { Empleado } from 'src/app/shared/model/empleado/empleado.model';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { AgregarEmpleadosBase } from 'src/app/shared/agregar-empleados/agregar-empleados-base';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-asignacion-equipo-qa',
  standalone: true,
  templateUrl: '../../../proyectos/admin-proyectos/modal-agregar-proyecto/agregar-empleados-proyecto/add-emp-proy.component.html',
  styleUrls: ['../modal-agregar-etapa.component.css'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    ScrollingModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule
  ],
})
export class AsignacionEquipoQaComponent extends AgregarEmpleadosBase {
  protected override readonly idArea = 2;

  /** La etapa escucha a QA con este nombre: es el mismo emisor de la base. */
  @Output() emmitResourcesQA = this.emmitResourcesDevelopers;

  /** La etapa entrega con este nombre los recursos ya asignados. */
  @Input()
  get recursosAsignadosQA(): Empleado[] {
    return this.recursosAsignadosDevelopers;
  }
  set recursosAsignadosQA(recursos: Empleado[]) {
    this.recursosAsignadosDevelopers = recursos;
  }
}
